"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Button from "@/components/ui/button";
import { useFeaturedShopItem } from "@/contexts/shop-catalog-provider";
import { ShopCartLine } from "@/types/shop";
import FeaturedItemHero, { FeaturedItemHeroSkeleton } from "./featured-item-hero";
const FeaturedItemPlacement: React.FC<{
  onAddLine: (line: ShopCartLine) => void;
}> = t0 => {
  const $ = _c(8);
  const {
    onAddLine
  } = t0;
  const {
    state,
    actions
  } = useFeaturedShopItem();
  const featured = state.featured;
  switch (featured.status) {
    case "none":
      {
        return null;
      }
    case "pending":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <FeaturedItemHeroSkeleton />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case "ready":
      {
        let t1;
        if ($[1] !== featured.item || $[2] !== onAddLine) {
          t1 = <FeaturedItemHero item={featured.item} onAddLine={onAddLine} />;
          $[1] = featured.item;
          $[2] = onAddLine;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "missing":
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div role="status" className="mb-10 rounded-2xl border border-border bg-background-secondary p-4 text-body text-foreground-secondary">This item is no longer available. Browse the shop below.</div>;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        return t1;
      }
    case "error":
      {
        let t1;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <p>We couldn't load this featured item. Browse the shop below.</p>;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        let t2;
        if ($[6] !== actions.retryFeatured) {
          t2 = <div role="alert" className="mb-10 flex flex-col items-start justify-between gap-3 rounded-2xl border border-status-warning-text/20 bg-status-warning-bg p-4 text-body text-status-warning-text sm:flex-row sm:items-center">{t1}<Button variant="secondary" size="sm" onClick={actions.retryFeatured} className="min-h-11 w-full cursor-pointer sm:w-auto">Try again</Button></div>;
          $[6] = actions.retryFeatured;
          $[7] = t2;
        } else {
          t2 = $[7];
        }
        return t2;
      }
  }
};
export default FeaturedItemPlacement;